<app-layout>
    <div class="main-container">
        <mat-card class="form-details-card">
            <mat-card-title class="header">
                <h1 appLocalizationPopupDirective localizationCode="FormDetails">{{ 'FormDetails' | translate: {Default: "Form Details"} }}</h1>
        
                <div class="buttons-container">
                    <button mat-raised-button setColor="primaryColour" color="primary" [disabled]="!form.valid" appPreventDoubleClick (throttledClick)="save()">
                        Save
                    </button>
                </div>
            </mat-card-title>
            <mat-card-content>
        
                <form class="form" *ngIf="form" [formGroup]="form">
        
                    <app-localization-text-form-field
                        [formElement]="{ formControl: 'name', localizationValueParam: 'text', text: ('FormName' | translate: {Default: 'Name'}), disabled: 'false' }"
                        [parentGroup]="form"
                        [cultures]="cultures"
                        (emitAddtoFormArray)="addNewLocalization()"
                        (emitDeleteFromFormArray)="deleteLocalization($event.index)"
                    ></app-localization-text-form-field>
        
                    <mat-form-field appearance="fill">
                        <mat-label>
                            Root Table
                        </mat-label>
        
                        <mat-select disableOptionCentering formControlName="table">
                            <mat-option *ngFor="let table of tables" [value]="table.id">{{table.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
        
                </form>
        
            </mat-card-content>
        </mat-card>
    </div>
</app-layout>